import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { hotlineChargePaymentDescriptionStyle, } from '@/feature/hotline/component/HotlineChargePaymentDescription/style';
/**
 * 料金お支払いについての説明
 */
export const HotlineChargePaymentDescription = (props) => {
    const { className = '', color, items } = props;
    const style = hotlineChargePaymentDescriptionStyle({ color });
    return (_jsxs("dl", Object.assign({ className: style.base({ class: className }) }, { children: [_jsx("dt", Object.assign({ className: style.title() }, { children: "\u6599\u91D1\u306E\u304A\u652F\u6255\u3044\u306B\u3064\u3044\u3066" })), _jsx("dt", { children: _jsx("ul", Object.assign({ className: style.list() }, { children: items.map((item, index) => (_jsx("li", Object.assign({ className: style.item() }, { children: item }), `HotlineChargePaymentDescription_${index + 1}`))) })) })] })));
};
